import { render } from "./NegociosContacto.vue?vue&type=template&id=30dbe72f&scoped=true"
import script from "./NegociosContacto.vue?vue&type=script&lang=js"
export * from "./NegociosContacto.vue?vue&type=script&lang=js"

import "./NegociosContacto.vue?vue&type=style&index=0&id=30dbe72f&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30dbe72f"]])

export default __exports__